import React from "react";
import MidwestDentalProgressTracker from "../../components/progressTracker/MidwestDentalProgressTracker";

const MidwestDentalEntryPage = ({
  configs,
  onStart,
  deviceType,
  steps = [],
}) => {
  // Default steps if not provided
  const progressSteps =
    steps.length > 0
      ? steps
      : ["Sleep Study History", "Referring Provider", "Dental Health"];

  return (
    <div className="midwest-dental-form-layout">
      {/* Fixed Header with Progress Tracker */}
      <div className="midwest-dental-fixed-header">
        <MidwestDentalProgressTracker
          steps={progressSteps}
          currentStep={null}
          deviceType={deviceType}
        />
      </div>

      {/* Scrollable Content */}
      <div className="midwest-dental-content-area">
        <div className="midwest-dental-entry-content-card">
          {configs?.logo && (
            <div className="midwest-dental-entry-logo-container">
              <img
                src={configs.logo}
                alt="Logo"
                className="midwest-dental-entry-logo"
              />
            </div>
          )}

          <div className="midwest-dental-entry-content">
            <div className="midwest-dental-entry-header">
              <h1 className="midwest-dental-entry-title">
                Schedule Your Appointment
              </h1>
              <p className="midwest-dental-entry-description">
                To make sure this visit is the right next step for you, we need
                to ask a few short screening questions. It will take about 2-3
                minutes.
              </p>
            </div>

            <div className="midwest-dental-entry-steps">
              <div className="midwest-dental-entry-step">
                <div className="midwest-dental-entry-step-number">1.</div>
                <div className="midwest-dental-entry-step-content">
                  <div className="midwest-dental-entry-step-title">
                    Sleep Study History
                  </div>
                  <div className="midwest-dental-entry-step-desc">
                    Confirm your prior sleep study details.
                  </div>
                </div>
              </div>

              <div className="midwest-dental-entry-step">
                <div className="midwest-dental-entry-step-number">2.</div>
                <div className="midwest-dental-entry-step-content">
                  <div className="midwest-dental-entry-step-title">
                    Referring Provider
                  </div>
                  <div className="midwest-dental-entry-step-desc">
                    Tell us who sent you our way.
                  </div>
                </div>
              </div>

              <div className="midwest-dental-entry-step">
                <div className="midwest-dental-entry-step-number">3.</div>
                <div className="midwest-dental-entry-step-content">
                  <div className="midwest-dental-entry-step-title">
                    Dental Health
                  </div>
                  <div className="midwest-dental-entry-step-desc">
                    A few questions about your current dental situation.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grow flex items-end">
            <div className="midwest-dental-entry-warning">
              <div className="midwest-dental-entry-warning-title">
                Important: Please Read Before Continuing
              </div>
              <div className="midwest-dental-entry-warning-text">
                Patients currently in orthodontic treatment (braces, clear
                aligners, or active retainers) are{" "}
                <span className="midwest-dental-entry-warning-highlight">
                  not eligible
                </span>{" "}
                to begin oral appliance therapy at this time. We recommend
                scheduling your consultation{" "}
                <span className="midwest-dental-entry-warning-highlight">
                  at least 6 months after completing orthodontic treatment
                </span>
                . If this applies to you, please call our office at{" "}
                <span className="midwest-dental-entry-warning-phone">
                  (312) 676-9892
                </span>{" "}
                and we'll add you to our future scheduling list.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed Footer */}
      <div className="bottom-bar-shadow">
        <div className="m-auto bottom-bar bottom-bar-entry-screen w-full midwest-dental-entry-footer">
          <div className="midwest-dental-entry-terms flex">
            <div>
              By clicking Get Started, you agree to our{" "}
              <a href="#" className="midwest-dental-entry-terms-link">
                Terms of Services
              </a>{" "}
              and{" "}
              <a href="#" className="midwest-dental-entry-terms-link">
                Privacy Policy
              </a>
              .
            </div>
          </div>
          <div
            className="primary_button midwest-dental-entry-button"
            onClick={onStart}
          >
            <span>Get Started</span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MidwestDentalEntryPage;
